import Section from '../../../elements/Section'
import Container from '../../../elements/Container'
import Column from '../../../layout/Column'
import Columns from '../../../layout/Columns'
import Highlight from '../../../custom/Highlight'
import Staff from '../../../custom/Staff'
import ContactForm from './components/ContactForm'
import styles from './styles.module.scss'
import { useResponsive } from '../../../../providers/ResponsiveContext'
import { withModifiers } from '../../../helpers/withModifiers'
import classNames from 'classnames'
import isEmpty from 'lodash-es/isEmpty'
import Grid from '../../../elements/Grid'
import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'

const Contact = ({
  title,
  description,
  variant = [],
  buying = true,
  separator = true,
  staff,
  leftLabel = true,
  disabled = false,
  sectionRef,
  route,
  translations
}) => {
  const { isTablet, isSmallMobile } = useResponsive()
  const isGeneral = variant.includes('general')
  const router = useRouter()

  const [loaded, setLoaded] = useState(false)
  useEffect(() => setLoaded(true), [])

  if (loaded) {
    return (
      <Section
        sectionRef={sectionRef}
        separator={separator}
        variant={[variant.includes('gray') ? 'gray' : 'white']}
      >
        <Container>
          <Columns
            variant={[isTablet ? '-align-center' : '-distribute-between']}
          >
            <Column spans={isSmallMobile ? 12 : isTablet ? 7 : 6}>
              {leftLabel && staff && !isEmpty(staff) && (
                <div
                  className={withModifiers(
                    'intro',
                    [isGeneral && 'general', !leftLabel && 'offset-top'],
                    styles
                  )}
                >
                  {leftLabel ? (
                    <>
                      {' '}
                      {translations.interestedIn[router.locale]}
                      <Highlight variant={['accent', 'font-primary']}>
                        {translations.buying[router.locale]}
                      </Highlight>{' '}
                      {translations.property[router.locale]}
                    </>
                  ) : (
                    ''
                  )}
                </div>
              )}

              <Grid>
                {staff &&
                  !isEmpty(staff) &&
                  staff.map((person, index) => (
                    <Staff
                      key={`contact-staff-${index}`}
                      width={isSmallMobile && 168}
                      height={isSmallMobile && 308}
                      variant={['inline', 'align-middle']}
                      {...person}
                      job={person.job[router.locale]}
                    />
                  ))}
              </Grid>
            </Column>

            <Column spans={isSmallMobile ? 12 : isTablet ? 11 : 6}>
              {description && (
                <span className={styles.description}>{description}</span>
              )}
              {isGeneral || title ? (
                <h2 className={styles.title}>
                  {title || translations.assistance[router.locale]}
                </h2>
              ) : (
                <div className={classNames(styles.intro, styles.last)}>
                  {translations.interestedIn[router.locale]}
                  <Highlight variant={['font-primary', buying && 'accent']}>
                    {buying
                      ? translations.buying[router.locale]
                      : translations.renting[router.locale]}
                  </Highlight>
                  {translations.thisProperty[router.locale]}
                </div>
              )}

              <ContactForm
                route={route}
                translations={translations}
                disabled={disabled}
              />
            </Column>
          </Columns>
        </Container>
      </Section>
    )
  }
  return
}

export default Contact
